/* product-gallery.js — galerie produit dominante + vignettes + lightbox (Chérie Charms)
   Vanilla JS, aucun rechargement. prefers-reduced-motion respecté. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var stage = root.querySelector('[data-stage]');
    if (!stage) return;

    var items = Array.prototype.slice.call(stage.querySelectorAll('[data-stage-item]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var lb = root.querySelector('[data-lightbox-modal]');
    var lbStage = lb ? lb.querySelector('[data-lb-stage]') : null;
    var current = 0;
    var lastFocus = null;

    /* ---- Sélection du média affiché dans l'emplacement principal ---- */
    function setActive(index) {
      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;

      items.forEach(function (it, i) {
        var on = i === index;
        it.classList.toggle('is-active', on);
        if (on) {
          it.removeAttribute('aria-hidden');
          if (it.hasAttribute('data-lightbox')) it.removeAttribute('tabindex');
        } else {
          it.setAttribute('aria-hidden', 'true');
          if (it.hasAttribute('data-lightbox')) it.setAttribute('tabindex', '-1');
          var vp = it.querySelector('video');
          if (vp) { try { vp.pause(); } catch (e) {} }
        }
      });

      thumbs.forEach(function (t, i) {
        var on = i === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });

      current = index;

      // lit la vidéo active (muet pour autoriser la lecture auto)
      var active = items[index];
      var v = active && active.querySelector('video');
      if (v) { v.muted = true; if (v.play) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
    }

    /* ---- Vignettes ---- */
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { setActive(parseInt(t.getAttribute('data-index'), 10)); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var ni = i + (e.key === 'ArrowRight' ? 1 : -1);
        if (ni < 0) ni = thumbs.length - 1;
        if (ni >= thumbs.length) ni = 0;
        setActive(ni);
        thumbs[ni].focus();
      });
    });

    /* ---- Clic image principale -> lightbox ---- */
    items.forEach(function (it) {
      if (it.hasAttribute('data-lightbox')) {
        it.addEventListener('click', function () { openLightbox(current); });
      }
    });

    /* ---- Lightbox ---- */
    function buildLbMedia(index) {
      if (!lbStage) return;
      lbStage.innerHTML = '';
      var it = items[index];
      if (it.getAttribute('data-type') === 'video') {
        var src = it.querySelector('video');
        if (src) {
          var clone = src.cloneNode(true);
          clone.classList.add('pdp-lightbox__media');
          clone.setAttribute('controls', '');
          clone.muted = false;
          lbStage.appendChild(clone);
        }
      } else {
        var img = document.createElement('img');
        img.className = 'pdp-lightbox__media';
        img.src = it.getAttribute('data-lb-src') || '';
        var ss = it.getAttribute('data-lb-srcset');
        if (ss) img.setAttribute('srcset', ss);
        img.setAttribute('sizes', '92vw');
        img.alt = it.getAttribute('data-lb-alt') || '';
        lbStage.appendChild(img);
      }
    }

    function openLightbox(index) {
      if (!lb) return;
      lastFocus = document.activeElement;
      setActive(index);
      buildLbMedia(index);
      lb.hidden = false;
      lb.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pdp-lb-open');
      requestAnimationFrame(function () { lb.classList.add('is-open'); });
      var closeBtn = lb.querySelector('[data-lb-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      if (!lb) return;
      lb.classList.remove('is-open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pdp-lb-open');
      var v = lbStage && lbStage.querySelector('video');
      if (v) { try { v.pause(); } catch (e) {} }
      var finish = function () { lb.hidden = true; if (lbStage) lbStage.innerHTML = ''; lb.removeEventListener('transitionend', finish); };
      if (reduce) { finish(); } else {
        var done = false;
        lb.addEventListener('transitionend', function h() { if (done) return; done = true; lb.removeEventListener('transitionend', h); finish(); });
        setTimeout(function () { if (!done) { done = true; finish(); } }, 300);
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function lbGo(delta) {
      var n = current + delta;
      if (n < 0) n = items.length - 1;
      if (n >= items.length) n = 0;
      setActive(n);
      buildLbMedia(n);
    }

    if (lb) {
      // masque les flèches s'il n'y a qu'un média
      if (items.length < 2) {
        var pn = lb.querySelectorAll('[data-lb-prev],[data-lb-next]');
        pn.forEach(function (b) { b.hidden = true; });
      }
      lb.querySelector('[data-lb-close]').addEventListener('click', closeLightbox);
      var prev = lb.querySelector('[data-lb-prev]');
      var next = lb.querySelector('[data-lb-next]');
      if (prev) prev.addEventListener('click', function () { lbGo(-1); });
      if (next) next.addEventListener('click', function () { lbGo(1); });

      // clic sur le fond ferme
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbStage) closeLightbox(); });

      // clavier : Échap ferme, flèches naviguent, Tab reste dans la lightbox
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') { closeLightbox(); }
        else if (e.key === 'ArrowLeft') { lbGo(-1); }
        else if (e.key === 'ArrowRight') { lbGo(1); }
        else if (e.key === 'Tab') {
          var f = Array.prototype.slice.call(lb.querySelectorAll('button:not([hidden])'));
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });

      // swipe mobile
      var sx = 0, sy = 0;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { lbGo(dx < 0 ? 1 : -1); }
      }, { passive: true });
    }

    setActive(0);
  });
})();
